import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-62aa12eb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "first-div-upload"
};
const _hoisted_2 = {
  class: "inner-div-text"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " To get started, download the template file and review the guidelines below before importing the file. ", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Download CSV template", -1));
const _hoisted_5 = {
  class: "second-div-upload"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "upload-div"
}, [/*#__PURE__*/_createElementVNode("p", null, "UPLOAD CSV FILE")], -1));
const _hoisted_7 = {
  class: "file-upload-area"
};
const _hoisted_8 = {
  class: "icon-div"
};
const _hoisted_9 = {
  class: "description-div"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1,
  class: "file-name"
};
const _hoisted_12 = {
  key: 2,
  class: "uploading-progres"
};
const _hoisted_13 = {
  key: 0,
  class: "info-div"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Supported format: CSV", -1));
const _hoisted_15 = {
  key: 0,
  class: "error-message"
};
const _hoisted_16 = {
  class: "import-guideline"
};
const _hoisted_17 = {
  class: "import-guideline-title"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Import guidelines", -1));
const _hoisted_19 = {
  class: "guideline-info"
};
const _hoisted_20 = {
  class: "guildline-field"
};
const _hoisted_21 = {
  style: {
    "position": "relative",
    "top": "-2px"
  }
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-text"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "guideline-text-title"
}, "Required Fields"), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("b", null, "Seller_id"), /*#__PURE__*/_createTextVNode(", "), /*#__PURE__*/_createElementVNode("b", null, "sku"), /*#__PURE__*/_createTextVNode(", and "), /*#__PURE__*/_createElementVNode("b", null, "asin"), /*#__PURE__*/_createTextVNode(" are mandatory fields.Ensure that each of these values is present in your CSV file before uploading. ")])], -1));
const _hoisted_23 = {
  class: "guildline-field"
};
const _hoisted_24 = {
  style: {
    "position": "relative",
    "top": "-2px"
  }
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-text"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "guideline-text-title",
  style: {
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("span", null, "Product Name "), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#4d4d4d"
  }
}, "(optional)")]), /*#__PURE__*/_createElementVNode("p", null, " This field is optional and only for your informational purposes. ")], -1));
const _hoisted_26 = {
  class: "guildline-field"
};
const _hoisted_27 = {
  style: {
    "position": "relative",
    "top": "-2px"
  }
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-text"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "guideline-text-title"
}, "COGS (Cost of Goods Sold)"), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" Enter numerical values only, using a period (.) for decimal points (e.g., 123.45). "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" Do not use commas (,) or spaces in the COGS field. ")])], -1));
const _hoisted_29 = {
  class: "guildline-field"
};
const _hoisted_30 = {
  style: {
    "position": "relative",
    "top": "-2px"
  }
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-text"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "guideline-text-title"
}, "Currency"), /*#__PURE__*/_createElementVNode("p", null, " Use the standard ISO 4217 currency codes (e.g., EUR, USD, GBP) for this field. ")], -1));
const _hoisted_32 = {
  class: "guildline-field"
};
const _hoisted_33 = {
  style: {
    "position": "relative",
    "top": "-2px"
  }
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-text"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "guideline-text-title",
  style: {
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("span", null, "External SKU "), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#4d4d4d"
  }
}, "(optional)")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" This field is optional and can be used for tracking in purchase orders and accounting reports. "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" If not needed, leave this field blank. ")])], -1));
const _hoisted_35 = {
  class: "guildline-field"
};
const _hoisted_36 = {
  style: {
    "position": "relative",
    "top": "-2px"
  }
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-text"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "guideline-text-title",
  style: {
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("span", null, "Product Segment "), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#4d4d4d"
  }
}, "(optional)")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" This field is optional and can be used for defining custom aggregates in the reports. "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" Leave blank to remove the segment from the product.. ")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_form_file = _resolveComponent("b-form-file");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_container = _resolveComponent("b-container");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_b_container, {
    fluid: "",
    style: {
      "padding": "0"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_b_row, {
      "no-gutters": ""
    }, {
      default: _withCtx(() => [_createVNode(_component_b_col, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
          class: "download-csv-template",
          onClick: _cache[0] || (_cache[0] = (...args) => $options.handleDownloadCSVClick && $options.handleDownloadCSVClick(...args))
        }, [_createVNode(_component_app_icon, {
          icon: "arrow-down"
        }), _hoisted_4])])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
          class: "upload-content",
          onDrop: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.handleDrop && $options.handleDrop(...args), ["prevent"])),
          onDragover: _cache[5] || (_cache[5] = _withModifiers((...args) => $options.handleDragOver && $options.handleDragOver(...args), ["prevent"])),
          onDragenter: _cache[6] || (_cache[6] = (...args) => $options.dragEnter && $options.dragEnter(...args)),
          onDragleave: _cache[7] || (_cache[7] = (...args) => $options.dragLeave && $options.dragLeave(...args))
        }, [_createElementVNode("div", _hoisted_8, [!$data.loading ? (_openBlock(), _createBlock(_component_app_icon, {
          key: 0,
          icon: "upload-icon-new",
          size: 40,
          color: "#595959"
        })) : _createCommentVNode("", true), $data.loading ? (_openBlock(), _createBlock(_component_app_icon, {
          key: 1,
          icon: "upload-processing-icon-new",
          size: 40
        })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [!$data.loading ? (_openBlock(), _createElementBlock("p", _hoisted_10, [_createTextVNode(" Drag & Drop here or "), _createElementVNode("span", {
          class: "click-to-upload",
          onClick: _cache[1] || (_cache[1] = (...args) => $options.triggerNativeFileInput && $options.triggerNativeFileInput(...args))
        }, "Choose your file")])) : _createCommentVNode("", true), $data.loading ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString($data.fileName), 1)) : _createCommentVNode("", true), $data.loading ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Uploading...")) : _createCommentVNode("", true)]), (_openBlock(), _createElementBlock("input", {
          type: "file",
          ref: "nativeFileInput",
          class: "d-none",
          onChange: _cache[2] || (_cache[2] = (...args) => $options.handleFileChange && $options.handleFileChange(...args)),
          accept: ".csv",
          key: $data.inputKey
        }, null, 32)), !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, $data.errorMessage ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($data.errorMessage), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_b_form_file, {
          modelValue: $data.selectedFile,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.selectedFile = $event),
          accept: ".csv",
          "drop-placeholder": "Drop files here...",
          class: "d-none"
        }, null, 8, ["modelValue"])], 32)])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_app_icon, {
          icon: "group"
        }), _hoisted_18]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_app_icon, {
          icon: "dot-circle"
        })]), _hoisted_22]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_app_icon, {
          icon: "dot-circle"
        })]), _hoisted_25]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_app_icon, {
          icon: "dot-circle"
        })]), _hoisted_28]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_app_icon, {
          icon: "dot-circle"
        })]), _hoisted_31]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_app_icon, {
          icon: "dot-circle"
        })]), _hoisted_34]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createVNode(_component_app_icon, {
          icon: "dot-circle"
        })]), _hoisted_37])])])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}